var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display"},[_c('embed',{staticClass:"embed",attrs:{"src":_vm.pdfUrl,"type":"application/pdf","width":"100%","height":_vm.screenHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }